import camelCase from 'lodash/camelCase';
import upperFirst from 'lodash/upperFirst';
/**
 * Converts the input to a correct displayName format for React.
 */
export const toDisplayName = (text) => upperFirst(camelCase(text));
//# sourceMappingURL=toDisplayName.js.map